/*! gara-tire-finder.js - YMM tire finder widget logic.
 * Extracted from snippets/gara-tire-finder.liquid (2026-05-29) so the
 * finder loads as a content-hash-versioned external asset. A CDN-cached
 * collection page then still fetches the CURRENT file (the /assets path is
 * constant; only ?v= changes), ending the stale-inline-JS desync where
 * deploys did not reach already-cached collection pages.
 * Reads window.GARA_TIRE_FINDER (gara-tire-finder-data.js) + window.GaraYMM.
 */
(function(){
  if (typeof window === 'undefined') return;
  function ready(fn){
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function(){
    var widget = document.querySelector('.gtf');
    if (!widget) return;
    var DB = window.GARA_TIRE_FINDER;            // tire SIZE data: DB.sizes (size->skus) + per-bike front/rear
    /* Build the YMM from the finder's gen/size-accurate bikes (DB.bikes, projected off the spine's
       tire by_year), PLUS any registry bike whose slug the finder has NO size for (kept selectable
       with the honest no-size message, so no bike vanishes). WHY (2026-06-22): the registry's year
       spans are GENERATION-over-broad — the base 'Diavel' slug carries 2019-2024 1260 part-fitment,
       so the registry offered "2023 Diavel", a year the base bike's spine size (2011-2018) can't
       serve -> the contradictory "we don't have a verified stock tire size" message while the spec
       sheet showed one. Using the finder's years for size-covered slugs offers the RIGHT generation
       (2023 Ducati -> "Diavel V4", not base "Diavel"), and every such offer has a size by construction. */
    var _reg = (window.GARA_BIKE_REGISTRY && window.GARA_BIKE_REGISTRY.bikes) || [];
    var _db = (DB && DB.bikes) || [];
    var _finderSlugs = {};
    _db.forEach(function (b) { if (b.slug) _finderSlugs[b.slug] = true; });
    var BIKES = _db.concat(_reg.filter(function (b) { return b.slug && !_finderSlugs[b.slug]; }));
    if (!BIKES.length) BIKES = _reg.length ? _reg : _db;
    if (!BIKES.length) {
      widget.style.display = 'none';
      return;
    }
    var yearSel  = widget.querySelector('[data-gtf-year]');
    var makeSel  = widget.querySelector('[data-gtf-make]');
    var modelSel = widget.querySelector('[data-gtf-model]');
    var reset    = widget.querySelector('[data-gtf-reset]');
    var result   = widget.querySelector('[data-gtf-result]');

    /* 1. Populate Year dropdown - all years across the registry, descending */
    var allYears = {};
    BIKES.forEach(function(b){
      var y1 = b.year_start, y2 = b.year_end || y1;
      /* Guard: a missing/garbage start year would flood the dropdown (null->0 emits
         years 0..year_end). Only real model years contribute. */
      if (!y1 || y1 < 1950 || y1 > 2030) return;
      if (!y2 || y2 < y1 || y2 > 2030) y2 = y1;
      for (var y = y1; y <= y2; y++) allYears[y] = true;
    });
    Object.keys(allYears).map(Number).sort(function(a,b){return b-a;}).forEach(function(y){
      var o = document.createElement('option');
      o.value = y; o.textContent = y;
      yearSel.appendChild(o);
    });

    function clearOptions(sel, placeholder){
      while (sel.options.length > 1) sel.remove(1);
      sel.options[0].textContent = placeholder;
      sel.value = '';
      sel.disabled = true;
    }

    function getBikesForYear(year){
      var y = Number(year);
      return BIKES.filter(function(b){
        var y1 = b.year_start || 0, y2 = b.year_end || y1;
        return y >= y1 && y <= y2;
      });
    }

    yearSel.addEventListener('change', function(){
      clearOptions(makeSel, 'Make');
      clearOptions(modelSel, 'Model');
      reset.hidden = !yearSel.value;
      if (!yearSel.value) {
        clearFilter();
        return;
      }
      /* First interaction: start loading the rest of the collection in the
         background so all matching cards are present by the time the rider
         finishes picking make + model (the count is index-authoritative either
         way, but this makes the grid itself complete without a visible wait). */
      loadAllRemainingPages();
      var bikes = getBikesForYear(yearSel.value);
      var makes = {};
      bikes.forEach(function(b){ if (b.make) makes[b.make] = true; });
      Object.keys(makes).sort().forEach(function(m){
        var o = document.createElement('option');
        o.value = m; o.textContent = m;
        makeSel.appendChild(o);
      });
      makeSel.disabled = false;
      showInterim('Now pick your make.');
    });

    makeSel.addEventListener('change', function(){
      clearOptions(modelSel, 'Model');
      if (!makeSel.value) return;
      var bikes = getBikesForYear(yearSel.value).filter(function(b){ return b.make === makeSel.value; });
      var models = {};
      bikes.forEach(function(b){ if (b.model) models[b.model] = true; });
      Object.keys(models).sort().forEach(function(m){
        var o = document.createElement('option');
        o.value = m; o.textContent = m;
        modelSel.appendChild(o);
      });
      modelSel.disabled = false;
      showInterim('And the model.');
    });

    modelSel.addEventListener('change', function(){
      if (!modelSel.value) return;
      /* Overlapping year ranges exist per model (the OE size changed across a
         model's life but rows can share an end year). Pick the row with the
         LATEST year_start that still contains the selected year - the most
         specific applicable spec - so e.g. a 2015 R1 gets 200/55, not a legacy
         190/50 from a broad 1998-2026 row. */
      var y = Number(yearSel.value);
      /* The SIZE comes from the tire dataset (GARA_TIRE_FINDER), matched by make/model/year. The dropdown
         bike came from the registry, so a bike with no size row here is normal -> honest message, bike
         stays selected. We never borrow another year's size (no deriving fitment). */
      var sizeBikes = (DB && DB.bikes) || [];
      var bike = null, bestYs = -1;
      sizeBikes.forEach(function(b){
        var y1 = b.year_start || 0, y2 = b.year_end || y1;
        if (y >= y1 && y <= y2 && b.make === makeSel.value && b.model === modelSel.value && y1 >= bestYs) {
          bike = b; bestYs = y1;
        }
      });
      saveYMM(yearSel.value, makeSel.value, modelSel.value, bike);
      if (!bike) {
        result.innerHTML = 'We don\'t have a verified stock tire size for your <strong>'
          + [yearSel.value, makeSel.value, modelSel.value].join(' ')
          + '</strong> on file yet, so all tires are shown below. We never guess a size.';
        applyFilter(null);
        return;
      }
      applyFilter(bike);
    });

    /* Restore saved YMM on page load so the collection-page "Clear all filters"
       button (which is a plain href navigation) doesn't wipe the rider's bike
       selection. Only the dedicated "Clear bike" button clears the YMM. */
    function restoreYMM(){
      var raw;
      try { raw = localStorage.getItem('gara_ymm'); } catch(_) { return; }
      if (!raw) return;
      var saved;
      try { saved = JSON.parse(raw); } catch(_) { return; }
      if (!saved || !saved.year || !saved.make || !saved.model) return;

      /* A bike is saved in the garage but the finder has no row matching it
         (most often the saved YEAR is outside the model's known span, e.g. a
         vintage year-of-record the tire data doesn't cover, or a phantom year).
         Without this, restore returned silently and the rider saw the ENTIRE
         unfiltered grid (tubes and all) as if a filter were applied - confusing,
         since they DID pick a bike. Tell them honestly instead. We never borrow
         another year's tire size to fill the gap (no deriving fitment). */
      function unmatched() {
        result.innerHTML = 'We don\'t have verified tire fitment for your <strong>'
          + [saved.year, saved.make, saved.model].join(' ')
          + '</strong> on file yet, so all tires are shown below. '
          + 'Use the year / make / model picker above to check a specific bike.';
      }

      /* SLUG-FIRST RESTORE (2026-08-14, the 2009 FXDC ad complaint): the old
         restore replayed the three dropdowns and BAILED on any display-string
         mismatch (registry names drift; the saved model may have been written
         by another surface). When it bailed, applyFilter never ran, the page
         loader never ran, and the grid sat on Shopify's 250-card page-1 subset
         with the grouper honestly reporting nonsense. The saved payload carries
         the stable identity (slug) and the resolved sizes — restore the FILTER
         from those directly; the dropdown replay below is cosmetic UI state. */
      function bikeFromSaved() {
        var y = Number(saved.year);
        var rows = (DB && DB.bikes) || [];
        var best = null, bestYs = -1;
        for (var i = 0; i < rows.length; i++) {
          var b = rows[i];
          var y1 = b.year_start || 0, y2 = b.year_end || y1;
          var slugHit = saved.slug && b.slug && b.slug === saved.slug;
          var nameHit = b.make === saved.make && b.model === saved.model;
          if ((slugHit || nameHit) && y >= y1 && y <= y2 && y1 >= bestYs) { best = b; bestYs = y1; }
        }
        if (best) return best;
        /* No finder row — fall back to the saved/garage sizes so the filter
           still applies (sizes came from the same spine projection). */
        var sz = (window.GaraYMM && GaraYMM.getTireSizes && GaraYMM.getTireSizes()) || saved;
        if (sz && (sz.front || sz.rear)) {
          return { make: saved.make, model: saved.model, style: 'unknown',
                   front: sz.front || null, rear: sz.rear || null,
                   front_alt: sz.front_alt || null, rear_alt: sz.rear_alt || null,
                   front_rating: sz.front_rating || null, rear_rating: sz.rear_rating || null };
        }
        return null;
      }

      /* Cosmetic dropdown replay — best-effort, never gates the filter. */
      yearSel.value = String(saved.year);
      if (yearSel.value === String(saved.year)) {
        yearSel.dispatchEvent(new Event('change'));
        makeSel.value = saved.make;
        if (makeSel.value === saved.make) {
          makeSel.dispatchEvent(new Event('change'));
          modelSel.value = saved.model;
          if (modelSel.value === saved.model) {
            modelSel.dispatchEvent(new Event('change'));
            return;   /* full replay worked — applyFilter already ran */
          }
        }
      }
      var restored = bikeFromSaved();
      if (!restored) { unmatched(); return; }
      loadAllRemainingPages();
      applyFilter(restored);
    }
    restoreYMM();

    /* Whatever surface selects the bike (garage, homepage YMM, this widget),
       start pulling the rest of the collection immediately — the family
       grouper's complete-set view can only render cards that exist in the DOM,
       and Shopify's paginate cap means page 1 alone rarely holds a bike's
       front+rear pair (2026-08-14 grid fix, with the parallel loader below). */
    document.addEventListener('gara-ymm:change', function (ev) {
      var d = ev && ev.detail;
      if (d && (d.front || d.rear)) loadAllRemainingPages();
    });

    /* Persist Y/M/M + the bike's known front/rear tire sizes so the cart
       suggester can match the exact stock size, not just family. */
    function saveYMM(y, m, mo, bike){
      var payload = {year: Number(y), make: m, model: mo};
      if (bike) {
        if (bike.slug) payload.slug = bike.slug;   // stable identity key; without it a trim
                                                   // display name matches nothing on the grids
        payload.front = bike.front || null;
        payload.rear  = bike.rear  || null;
        payload.front_alt = bike.front_alt || null;
        payload.rear_alt  = bike.rear_alt  || null;
      }
      /* Single owner: GaraYMM stores the bike + resolved sizes, mirrors them to
         cart attributes (server pre-pick) and fires gara-ymm:change. */
      if (window.GaraYMM && typeof window.GaraYMM.set === 'function') {
        window.GaraYMM.set(payload);
        return;
      }
      try {
        localStorage.setItem('gara_ymm', JSON.stringify(payload));
        document.dispatchEvent(new CustomEvent('gara-ymm:change', {detail: payload}));
      } catch(_) {}
    }

    reset.addEventListener('click', function(){
      yearSel.value = '';
      clearOptions(makeSel, 'Make');
      clearOptions(modelSel, 'Model');
      reset.hidden = true;
      result.textContent = '';
      clearFilter();
      if (window.GaraYMM && typeof window.GaraYMM.clear === 'function') {
        window.GaraYMM.clear();
      } else {
        try {
          localStorage.removeItem('gara_ymm');
          document.dispatchEvent(new CustomEvent('gara-ymm:change', {detail: null}));
        } catch(_) {}
      }
    });

    function showInterim(msg){
      result.innerHTML = '<em>' + msg + '</em>';
      clearFilter();
    }
    function clearFilter(){
      /* Entering (or clearing) the bike path always ends shop-by-size mode —
         the two filters both paint .gtf-hidden and must never stack. */
      if (activeSize) exitSizeMode(false);
      document.querySelectorAll('.gtf-hidden').forEach(function(el){
        el.classList.remove('gtf-hidden');
      });
      setPagination(true);   // restore Shopify pagination when no bike is active
      setEmptyState(false);
    }

    /* When a bike is selected the grid is filtered + lazy-merged client-side, so
       Shopify's server pagination ("page 2, 3 ...") points at pages whose products
       are now either already merged in or filtered out - i.e. they render EMPTY.
       Hide the pagination nav while a bike filter is active so a rider never lands
       on a "2 more pages with nothing on them" dead end. Restored on Clear bike. */
    function setPagination(show){
      document.querySelectorAll('.gara-pagination, nav[aria-label="Pagination"]').forEach(function(el){
        el.style.display = show ? '' : 'none';
      });
    }
    /* Friendly empty state when a bike matches zero tires in this collection. */
    function setEmptyState(on, label){
      var grid = document.querySelector('.gara-product-grid');
      if (!grid) return;
      var box = document.getElementById('gtf-empty');
      if (on) {
        if (!box) {
          box = document.createElement('div');
          box.id = 'gtf-empty';
          box.className = 'gara-coll-empty is-visible';
          grid.appendChild(box);
        }
        box.innerHTML = '<div class="gara-coll-empty-title">No tires on file for ' + (label || 'this bike') + '</div>' +
          '<div class="gara-coll-empty-sub">We don\'t have a stocked tire in this bike\'s size yet. ' +
          '<a href="#" onclick="if(window.GaraYMM){window.GaraYMM.clear()}return false;">Clear the bike</a> to see every tire.</div>';
        box.style.display = '';
      } else if (box) {
        box.style.display = 'none';
      }
    }

    /* Find all product cards on the page. The Gara theme renders each
       product as <a class="gara-pcard" data-sku="...">. */
    function getProductCards(){
      return document.querySelectorAll('.gara-pcard[data-sku]');
    }
    function cardSku(card){
      return card.getAttribute('data-sku');
    }

    /* Lazy-load additional collection pages so the relevance sort can
       see every matching tire. Shopify caps a single Liquid `paginate`
       render at ~250 cards, but a tire collection can have 500+ SKUs.
       Without this fetch, a bike whose stock sizes match SKUs on page 2+
       silently misses them: the sort can only reorder cards that exist
       in DOM.

       Cache by URL so picking different bikes doesn't re-fetch. */
    var _allPagesLoaded = false;
    var _loadAllPromise = null;
    function loadAllRemainingPages(){
      if (_allPagesLoaded) return Promise.resolve();
      if (_loadAllPromise) return _loadAllPromise;
      var basePath = window.location.pathname;
      /* CARRY ?view= INTO THE PAGE FETCHES (2026-08-15, shop-by-size review):
         the full tire wall is /collections/moto-tires?view=wall — the bare
         pathname renders the CATLAND LANDING (tiles, ZERO product cards), so a
         view-less ?page=2 fetch returned no cards, the loop read "end of
         collection", and _allPagesLoaded lied with only page 1 in the DOM
         (size mode then showed a false "we don't stock this size"). */
      var viewM = window.location.search.match(/[?&]view=([^&]+)/);
      var pageQS = (viewM ? '?view=' + viewM[1] + '&' : '?') + 'page=';
      /* The page the rider is ALREADY ON — its cards are in the DOM; skip it. */
      var curPage = parseInt((window.location.search.match(/[?&]page=(\d+)/) || [])[1] || '1', 10);
      /* The MAIN grid by id — the first .gara-product-grid by class can be the
         Bestsellers featured rail's grid; fetched cards must land in the main
         grid, never the rail. */
      var grid = document.getElementById('gara-product-grid') || document.querySelector('.gara-product-grid');
      if (!grid) { _allPagesLoaded = true; return Promise.resolve(); }
      _loadAllPromise = (async function(){
        /* PARALLEL page fetch (2026-08-14): the old loop fetched pages 2..N one
           at a time — seven ~sequential full-HTML round-trips, which on a weak
           mobile connection never finished, so the grid stayed a 250-card
           page-1 subset and the family grouper judged "no complete set" off
           it (the 2009 FXDC ad complaint). Fetch in bursts of 4; append in
           PAGE ORDER. Fetch 1..N (a rider can ENTER on ?page=3 — page 1 is
           then missing from the DOM) and stop only at a page with ZERO cards
           (truly past the end) — a page of already-present dupes proves the
           collection continues, not that it ended (2026-08-15 review). */
        var maxPages = 15;
        var existingSkus = {};
        grid.querySelectorAll('.gara-pcard[data-sku]').forEach(function(c){
          existingSkus[c.getAttribute('data-sku')] = true;
        });
        function fetchPage(page){
          return fetch(basePath + pageQS + page, {credentials:'same-origin'})
            .then(function(resp){ return resp.ok ? resp.text() : null; })
            .then(function(html){
              if (!html) return null;
              var doc = new DOMParser().parseFromString(html, 'text/html');
              return doc.querySelectorAll('.gara-pcard[data-sku]');
            })
            .catch(function(){ return null; });
        }
        var appendedAny = false, page = 1, done = false;
        while (!done && page <= maxPages) {
          var burst = [];
          for (var p = page; p < page + 4 && p <= maxPages; p++) {
            burst.push(p === curPage ? Promise.resolve('skip') : fetchPage(p));
          }
          var results = await Promise.all(burst);
          for (var i = 0; i < results.length; i++) {
            var newCards = results[i];
            if (newCards === 'skip') continue;
            if (!newCards || newCards.length === 0) { done = true; break; }
            var appended = 0;
            newCards.forEach(function(card){
              var sku = card.getAttribute('data-sku');
              if (sku && !existingSkus[sku]) { existingSkus[sku] = true; grid.appendChild(card); appended++; }
            });
            if (appended) appendedAny = true;
          }
          page += 4;
        }
        _allPagesLoaded = true;
        /* Tell the family grouper the grid grew even when no applyFilter re-run
           follows (the grouper listens site-wide; without this the appended
           cards stay unclassified and the complete-set verdict stays wrong). */
        if (appendedAny) {
          try { document.dispatchEvent(new CustomEvent('gara-grid:refilled')); } catch(_){}
        }
      })();
      return _loadAllPromise;
    }

    /* Core of a tire size — width/aspect/rim only — so "120/70-17",
       "120/70 ZR17" and "120/70ZR17" all compare equal. DB.sizes is keyed by
       RAW labels (ZR/R/dash variants are separate keys), while a bike carried
       from its spec sheet brings the SPINE's plain "120/70-17" string; an
       exact DB.sizes[sz] hit silently missed every other label variant. */
    function sizeCore(s){
      var m = String(s || '').match(/(\d{2,3})\s*\/\s*(\d{2,3})\D*?(\d{2})\b/);
      return m ? (m[1] + '/' + m[2] + '/' + m[3]) : '';
    }

    /* ── SHOP BY SIZE (the no-bike path, Benjamin 2026-08-15) ────────────────
       A rider without a bike selected picks their sidewall size from a dropdown
       and the grid filters to tires available in that size. Options are built
       from DB.sizes' own keys (single source — never a hand list), DEDUPED to
       one option per physical size across the three label notations the catalog
       carries: metric ("120/70-17" / "120/70 ZR17" / "120/70ZR17" -> one
       "120/70-17" option), inch-bias ("3.5-19" / "3.50-19" -> "3.50-19"), and
       alpha ("MT90B16" / "MT90 B16" / "MT90-16" -> "MT90B16"). Grouped by rim
       diameter. Picking a size matches EVERY raw label behind that option, so
       no label variant is ever silently dropped (the exact-key-miss class).
       Size mode and the bike filter are mutually exclusive: the row hides while
       a bike is active (the bike's verified stock size beats a hand-picked one),
       and selecting a bike anywhere exits size mode. */
    var sizeRow = widget.querySelector('[data-gtf-sizerow]');
    var sizeSel = widget.querySelector('[data-gtf-size]');
    var sizeClear = widget.querySelector('[data-gtf-sizeclear]');   /* shown only while a size is active */
    var activeSize = null;      /* display label while size mode is on */
    var _sizeKeyMap = null;     /* option label -> [raw DB.sizes keys] */

    function escText(s){
      var d = document.createElement('div');
      d.textContent = s == null ? '' : String(s);
      return d.innerHTML;
    }

    function bikeActive(){
      try {
        var v = JSON.parse(localStorage.getItem('gara_ymm') || 'null');
        return !!(v && v.year && v.make && v.model);
      } catch(_) { return false; }
    }

    /* Canonical option for one raw DB.sizes key: {label, rim, kind, ord}.
       kind orders notations within a rim group (metric, inch, alpha, other). */
    function canonSize(k){
      var s = String(k || '').trim();
      var m = s.match(/(\d{2,3})\s*\/\s*(\d{2,3})\D*?(\d{2})\b/);
      if (m) {
        return { label: m[1] + '/' + m[2] + '-' + m[3], rim: parseInt(m[3], 10),
                 kind: 0, ord: parseInt(m[1], 10) * 1000 + parseInt(m[2], 10) };
      }
      m = s.match(/^(\d{1,2}(?:\.\d{1,2})?)\s*-\s*(\d{1,2})$/);
      if (m) {
        var w = parseFloat(m[1]);
        return { label: w.toFixed(2) + '-' + m[2], rim: parseInt(m[2], 10),
                 kind: 1, ord: Math.round(w * 100) };
      }
      /* Alpha sizes: "MT90B16", "MT90 B16" and "MT90-16" are one size. Match the
         RAW string (never strip the separator first — "MH90-10" stripped becomes
         "MH9010", which splits ambiguously as MH901+0). */
      m = s.toUpperCase().match(/^([A-Z]{2}\d{2,3})[\s-]*B?[\s-]*(\d{1,2})$/);
      if (m) {
        return { label: m[1] + 'B' + m[2], rim: parseInt(m[2], 10), kind: 2, ord: 0 };
      }
      return { label: s, rim: 0, kind: 3, ord: 0 };
    }

    /* Build the label->raw-keys map once and fill the dropdown (rim optgroups,
       ascending; unparsable labels last under "Other sizes"). */
    function buildSizeIndex(){
      if (_sizeKeyMap) return _sizeKeyMap;
      _sizeKeyMap = {};
      var groups = {};
      Object.keys((DB && DB.sizes) || {}).forEach(function(k){
        var c = canonSize(k);
        (_sizeKeyMap[c.label] = _sizeKeyMap[c.label] || []).push(k);
        var g = (groups[c.rim] = groups[c.rim] || {});
        if (!g[c.label]) g[c.label] = c;
      });
      Object.keys(groups).map(Number).sort(function(a, b){
        if (!a) return 1;                 /* rim-unknown group sinks to the end */
        if (!b) return -1;
        return a - b;
      }).forEach(function(rim){
        var og = document.createElement('optgroup');
        og.label = rim ? (rim + '" rim') : 'Other sizes';
        Object.keys(groups[rim]).map(function(l){ return groups[rim][l]; })
          .sort(function(a, b){
            return (a.kind - b.kind) || (a.ord - b.ord) ||
                   (a.label < b.label ? -1 : (a.label > b.label ? 1 : 0));
          })
          .forEach(function(c){
            var o = document.createElement('option');
            o.value = c.label;
            o.textContent = c.label;
            og.appendChild(o);
          });
        sizeSel.appendChild(og);
      });
      return _sizeKeyMap;
    }

    /* Leave size mode. repaint=true restores the unfiltered grid (rider chose
       "All sizes"); repaint=false only drops state — used when the bike path is
       taking over and will paint its own filter over the same cards. */
    function exitSizeMode(repaint){
      activeSize = null;
      if (sizeSel) sizeSel.value = '';
      if (sizeClear) sizeClear.hidden = true;
      try { sessionStorage.removeItem('gara_tire_size'); } catch(_) {}
      setSizeEmptyState(false);
      if (repaint) {
        document.querySelectorAll('.gtf-hidden').forEach(function(el){
          el.classList.remove('gtf-hidden');
        });
        setPagination(true);
        result.textContent = '';
        try { document.dispatchEvent(new CustomEvent('gara-grid:refilled')); } catch(_) {}
      }
    }

    /* Honest empty state for size mode. On a sub-category page it links to the
       full tire wall carrying the size (the size may live in another bucket);
       on the all-tires wall itself zero really means we don't stock it. */
    function setSizeEmptyState(on, label){
      var box = document.getElementById('gtf-size-empty');
      if (!on) { if (box) box.style.display = 'none'; return; }
      /* The MAIN grid by id — the first .gara-product-grid by class can be the
         Bestsellers featured RAIL's grid, which would put this box under the
         "Bestsellers" heading (2026-08-15 review). */
      var grid = document.getElementById('gara-product-grid') || document.querySelector('.gara-product-grid');
      if (!grid) return;
      if (!box) {
        box = document.createElement('div');
        box.id = 'gtf-size-empty';
        box.className = 'gara-coll-empty is-visible';
        grid.appendChild(box);
      }
      var onAllTires = /\/collections\/moto-tires\/?$/.test(window.location.pathname);
      var wallLink = '/collections/moto-tires?view=wall&size=' + encodeURIComponent(label);
      box.innerHTML = '<div class="gara-coll-empty-title">No ' + escText(label) + ' tires in this collection</div>' +
        '<div class="gara-coll-empty-sub">' +
        (onAllTires
          ? 'We don\'t stock this size yet.'
          : '<a href="' + wallLink + '">See every tire we stock in ' + escText(label) + '</a>') +
        '</div>';
      box.style.display = '';
    }

    function applySizeFilter(label){
      var map = buildSizeIndex();
      var keys = map[label] || [];
      var match = {};
      keys.forEach(function(k){
        (DB.sizes[k] || []).forEach(function(e){ if (e && e.sku) match[e.sku] = true; });
      });
      activeSize = label;
      if (sizeClear) sizeClear.hidden = false;
      try { sessionStorage.setItem('gara_tire_size', label); } catch(_) {}
      function paint(){
        if (activeSize !== label) return;   /* superseded by a newer pick/clear */
        /* Count DISTINCT SKUs, not cards — the Bestsellers featured rail
           renders the same product a second time with the same data-sku, and a
           card count would state an inflated number as fact. */
        var shownSkus = {};
        document.querySelectorAll('.gara-pcard[data-sku]').forEach(function(card){
          card.style.order = '';
          var sku = card.getAttribute('data-sku');
          if (match[sku]) {
            card.classList.remove('gtf-hidden');
            shownSkus[sku] = true;
          } else {
            card.classList.add('gtf-hidden');
          }
        });
        var shown = Object.keys(shownSkus).length;
        setPagination(false);
        var done = _allPagesLoaded;
        result.innerHTML = done
          ? '<strong>' + shown + '</strong> tire' + (shown === 1 ? '' : 's') + ' in <strong>' + escText(label) +
            '</strong> in this collection, grouped by family below. Tap one to pick front or rear.'
          : 'Showing <strong>' + escText(label) + '</strong> tires. <em>Loading the rest...</em>';
        setSizeEmptyState(done && shown === 0, label);
        try { document.dispatchEvent(new CustomEvent('gara-grid:refilled')); } catch(_) {}
      }
      paint();
      loadAllRemainingPages().then(paint);
    }

    /* Show the row only while no bike is active; a bike appearing (garage,
       mega-nav, homepage YMM, this widget) hides it and drops any active size
       filter WITH a full repaint (exitSizeMode(true)) — an EXTERNALLY-set bike
       never runs this widget's applyFilter, so repaint=false would leave the
       abandoned size filter's .gtf-hidden painted under the grouper's bike
       view (empty grid beneath a "complete sets for your bike" banner —
       2026-08-15 review blocker). On the widget's OWN path the transient
       unhide is harmless: applyFilter(bike) runs right after and repaints. */
    function syncSizeRow(){
      if (!sizeRow) return;
      if (bikeActive()) {
        sizeRow.hidden = true;
        if (activeSize) exitSizeMode(true);
      } else {
        buildSizeIndex();
        sizeRow.hidden = false;
        /* The ?shopbysize "clear your bike first" hint is moot once the bike
           IS cleared — drop it so it can't sit stale beside the live size row. */
        document.querySelectorAll('[data-gtf-sizehint]').forEach(function(h){ h.remove(); });
      }
    }

    function initShopBySize(){
      if (!sizeRow || !sizeSel || !DB || !DB.sizes) {
        if (sizeRow) sizeRow.hidden = true;
        return;
      }
      syncSizeRow();
      sizeSel.addEventListener('change', function(){
        if (!sizeSel.value) { exitSizeMode(true); return; }
        loadAllRemainingPages();
        applySizeFilter(sizeSel.value);
      });
      /* "Clear size" (Benjamin 2026-08-15): one tap back to All sizes — same
         full restore as picking the placeholder option. */
      if (sizeClear) {
        sizeClear.addEventListener('click', function(){ exitSizeMode(true); });
      }
      document.addEventListener('gara-ymm:change', syncSizeRow);
      /* ?shopbysize=1 (the landing's "Shop by Tire Size" button): bring the
         widget into view with the size menu ready — even when a bike is
         active, so the click never silently no-ops. */
      var wantsShopBySize = /[?&]shopbysize=/.test(window.location.search);
      if (wantsShopBySize) {
        try { widget.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch(_) {}
      }
      if (bikeActive()) {
        /* Bike supersedes any remembered size — clear it so it can't resurrect
           after the bike is later cleared on some other page. */
        try { sessionStorage.removeItem('gara_tire_size'); } catch(_) {}
        if (wantsShopBySize) {
          /* Own element, NOT result.innerHTML — the bike path's async second
             applyFilter pass rewrites the result line and would wipe a hint
             appended there. */
          var hint = document.createElement('div');
          hint.className = 'gtf__result';
          hint.setAttribute('data-gtf-sizehint', '1');
          hint.innerHTML = '<em>Shopping by size? While a bike is selected, its stock sizes drive ' +
            'the grid. Hit <strong>Clear bike</strong> above to pick a size yourself.</em>';
          result.parentNode.insertBefore(hint, result.nextSibling);
        }
        return;
      }
      /* Deep link (?size= from the landing/wall links) beats the sticky
         session size; both only when no bike is active. */
      var want = null;
      var qm = window.location.search.match(/[?&]size=([^&]+)/);
      if (qm) { try { want = decodeURIComponent(qm[1].replace(/\+/g, ' ')); } catch(_) { want = null; } }
      if (!want) { try { want = sessionStorage.getItem('gara_tire_size'); } catch(_) {} }
      if (want && buildSizeIndex()[want]) {
        sizeSel.value = want;
        loadAllRemainingPages();
        applySizeFilter(want);
      }
      if (wantsShopBySize) {
        try { sizeSel.focus({ preventScroll: true }); } catch(_) {}
      }
    }
    initShopBySize();

    /* Service-rating comparison — IDENTICAL to gara-tire-card-grouper.js (the PDP
       "Below / Meets / Exceeds OEM rating" badge), so the finder and the PDP can
       NEVER disagree: a tire the finder shows must never read "Below OEM" on its
       own page (the 2006 R6 bug — Scorpion Rally STR 58V/73V passed a load-only
       gate but is BELOW the OE 58W/73W on SPEED). Load AND speed are judged
       INDEPENDENTLY: below if EITHER falls short (a faster speed letter must not
       mask a short load, nor a higher load mask a slower speed). */
    function ratingParts(r){
      if (!r) return null;
      var SPEED_ORDER = 'BCDEFGHJKLMNPQRSTUVWY';   // local so it can't be undefined when
                                                   // restore-on-load calls this before a
                                                   // module-var assignment would have run.
      var up = String(r).toUpperCase();
      var sm = up.match(/([B-Y])\s*$/);
      var lm = up.match(/^(\d{2,3})/);
      return {
        speed: (sm && SPEED_ORDER.indexOf(sm[1]) >= 0) ? SPEED_ORDER.indexOf(sm[1]) : -1,
        load: lm ? parseInt(lm[1], 10) : -1
      };
    }
    function compareOE(tireRating, oeRating){
      var t = ratingParts(tireRating), o = ratingParts(oeRating);
      if (!t || !o || (o.speed < 0 && o.load < 0)) return null;
      var speedShort = o.speed >= 0 && t.speed >= 0 && t.speed < o.speed;
      var loadShort  = o.load  >= 0 && t.load  >= 0 && t.load  < o.load;
      if (speedShort || loadShort) return 'below';
      var speedOver = o.speed >= 0 && t.speed >= 0 && t.speed > o.speed;
      var loadOver  = o.load  >= 0 && t.load  >= 0 && t.load  > o.load;
      return (speedOver || loadOver) ? 'exceeds' : 'meets';
    }
    /* True when the bike has a usable OE service rating for a position, so the gate engages. */
    function hasOE(oeRating){ var o = ratingParts(oeRating); return !!o && (o.speed >= 0 || o.load >= 0); }

    function applyFilter(bike){
      /* No bike, or a matched bike that has NO verified size on file: show EVERY
         tire family. The caller has already set the honest "all tires shown"
         message. Without this guard, an empty wantedSizes filtered against the
         whole grid and hid every card - so an unknown-size bike saw ZERO tires
         even though the message promised all of them. clearFilter() restores the
         cards, the pagination, and clears the empty state; we never touch the
         message here so the caller's wording stands. */
      if (!bike || (!bike.front && !bike.rear && !bike.front_alt && !bike.rear_alt)) {
        clearFilter();
        return;
      }
      /* Each wanted size carries the OE SERVICE RATING (load+speed) for its
         position so we can drop same-size tires that don't meet the bike's stock
         rating. front + front_alt share the bike's front_rating; rear + rear_alt
         share rear_rating. No usable OE for a position (~31% of bikes, mostly
         dirt) -> size-only, gate off for that position. */
      var wanted = [];
      if (bike) {
        var fr = bike.front_rating, rr = bike.rear_rating;
        if (bike.front)     wanted.push({core: sizeCore(bike.front),     raw: bike.front,     oe: fr});
        if (bike.front_alt) wanted.push({core: sizeCore(bike.front_alt), raw: bike.front_alt, oe: fr});
        if (bike.rear)      wanted.push({core: sizeCore(bike.rear),      raw: bike.rear,      oe: rr});
        if (bike.rear_alt)  wanted.push({core: sizeCore(bike.rear_alt),  raw: bike.rear_alt,  oe: rr});
      }
      var wantedSizes = wanted.map(function(w){ return w.raw; });
      var matchingSkus = {};
      Object.keys((DB && DB.sizes) || {}).forEach(function(k){
        var kc = sizeCore(k);
        /* Which wanted positions does this size bucket satisfy? Match by core
           (label-variant safe) or exact raw (alpha sizes like MT90B16 whose core
           is empty). */
        var ents = wanted.filter(function(w){ return (w.core && w.core === kc) || w.raw === k; });
        if (!ents.length) return;
        (DB.sizes[k] || []).forEach(function(h){
          /* Keep the tire only if, for SOME satisfied position, the bike has no
             usable OE rating (size-only) OR the tire MEETS/EXCEEDS the OE service
             rating (load AND speed). A tire BELOW on either dimension, or with no
             usable rating when the OE is known, is dropped — the SAME verdict the
             PDP badge shows, so a finder result never reads "Below OEM rating". */
          var ok = ents.some(function(w){
            if (!hasOE(w.oe)) return true;
            var v = compareOE(h.rating, w.oe);
            return v === 'meets' || v === 'exceeds';
          });
          if (ok) matchingSkus[h.sku] = true;
        });
      });

      /* If matching SKUs likely span beyond the first rendered page,
         fetch the rest of the collection then re-run this filter. The
         second pass renders all cards. */
      /* The AUTHORITATIVE match count is the index union (every tire in the
         catalog in the bike's sizes) - NOT how many cards happen to be in the
         DOM right now. The old code showed the DOM count, so while the finder
         lazily fetched pages 2-3 the rider saw a misleading partial number
         (2, then 21, ...). We always show the true total from the index; if the
         matching cards aren't all loaded yet we kick off the fetch in the
         background and re-run to fill the grid, but the number stays correct. */
      var totalMatching = Object.keys(matchingSkus).length;
      var skusPresent = 0;
      document.querySelectorAll('.gara-pcard[data-sku]').forEach(function(c){
        if (matchingSkus[c.getAttribute('data-sku')]) skusPresent++;
      });
      if (!_allPagesLoaded && skusPresent < totalMatching) {
        loadAllRemainingPages().then(function(){ applyFilter(bike); });
      }

      /* Relevance ranking: if we know the bike's riding style and the tire's
         style family, score each matching tire and use CSS `order` to put
         the most relevant tires first. Unknown bike-style -> no reorder
         (everything gets order 0, original DOM order preserved). */
      var skuStyle = DB.sku_to_style || {};
      var styleScore = DB.style_score || {};
      var bikeStyle = (bike && bike.style) || 'unknown';
      var scoreTable = styleScore[bikeStyle] || null;

      var cards = getProductCards();
      var shown = 0, hidden = 0;
      cards.forEach(function(card){
        var sku = cardSku(card);
        if (!sku) return;
        if (matchingSkus[sku]) {
          card.classList.remove('gtf-hidden');
          shown++;
          /* Sold-out always sinks to the bottom, even when relevance-sorting,
             so in-stock shows first. (CSS `.oos { order:100 }` handles the
             no-filter case; this keeps it true once we set inline order.) */
          if (card.classList.contains('oos')) {
            card.style.order = '100';
          } else if (scoreTable) {
            var tStyle = skuStyle[sku] || 'unknown';
            var score = scoreTable[tStyle];
            if (typeof score !== 'number') score = 0;
            /* Flexbox/grid `order` sorts ascending - invert score so higher = first. */
            card.style.order = String(-score);
          } else {
            card.style.order = '';
          }
        } else {
          card.classList.add('gtf-hidden');
          card.style.order = '';
          hidden++;
        }
      });
      var bikeLabel = bike ? (bike.make + ' ' + bike.model + ' ' + yearSel.value) : '';
      var sizesLabel = wantedSizes.filter(Boolean).join(' / ');
      /* Count = authoritative index total. `loadingMore` only affects whether we
         append a "filling in..." note while background pages finish. */
      var loadingMore = !_allPagesLoaded && shown < totalMatching;
      /* Bike active -> kill the now-meaningless server pagination, and show a
         graceful empty state if nothing in this collection fits. */
      if (bike) {
        setPagination(false);
        setEmptyState(totalMatching === 0, bikeLabel);
      }
      result.innerHTML = '<strong>' + bikeLabel + '</strong> uses ' + sizesLabel
                       + '. <strong>' + totalMatching + '</strong> matching tire' + (totalMatching === 1 ? '' : 's')
                       + ' fit, grouped by family below. Tap one to pick front or rear.'
                       + (scoreTable ? ' Sorted by relevance for ' + bikeStyle.replace('-', ' ') + ' riding.' : '')
                       + (loadingMore ? ' <em>Loading the rest...</em>' : '');
      /* Tell the family grouper to (re-)collapse: lazy-loaded pages 2-3 append
         cards AFTER the grouper's first pass, so without this the appended
         matching cards show ungrouped (front+rear duplicates). */
      try { document.dispatchEvent(new CustomEvent('gara-grid:refilled')); } catch (_) {}
    }
  });
})();
